export const CHUNK_RELOAD_KEY = 'chunk_reload_attempted';

export function hasChunkReloadBeenAttempted(): boolean {
  try {
    return sessionStorage.getItem(CHUNK_RELOAD_KEY) === '1';
  } catch {
    return false;
  }
}

export function markChunkReloadAttempted(): void {
  try {
    sessionStorage.setItem(CHUNK_RELOAD_KEY, '1');
  } catch {
    // sessionStorage unavailable — proceed without guard
  }
}

export function clearChunkReloadAttempt(): void {
  try {
    sessionStorage.removeItem(CHUNK_RELOAD_KEY);
  } catch {
    // ignore
  }
}

export function reloadOnceForStaleChunk(): boolean {
  if (hasChunkReloadBeenAttempted()) {
    return false;
  }
  markChunkReloadAttempted();
  window.location.reload();
  return true;
}

export function isChunkLoadError(error: unknown): boolean {
  if (!(error instanceof Error)) {
    return false;
  }
  if (error.name === 'ChunkLoadError') return true;
  if (error instanceof SyntaxError) return true;
  const message = error.message ?? '';
  return (
    message.includes('Loading chunk') ||
    message.includes('Loading CSS chunk') ||
    message.includes("Unexpected token '<'") ||
    message.includes('Failed to fetch dynamically imported module') ||
    message.includes('Chunk reload timed out')
  );
}
